
import { Rate} from "ant-design-vue";
const {...other } = Rate;
const YwRate = {
	...other,
	name: "YwRate",
};

YwRate.install = function (Vue) {
	Vue.component(YwRate.name, Rate);
};                                
export default YwRate;
